import React from "react";
import { Box, Grid, TextField, Typography } from "@mui/material";
import { LabeledField } from "@/__core/components/LabeledField";
import AddressFieldWrapper from "@/modules/addresses/components/AddressFieldWrapper";
import { AddressFieldValue } from "@/modules/addresses/hooks/useAddressField";

interface DeliveryInformationSectionProps {
  deliveryPhone?: string;
  initialAddress: AddressFieldValue | null;
  disabled?: boolean;
  onDeliveryPhoneChange: (value: string) => void;
  onAddressChange: (addressValue: AddressFieldValue) => void;
}

export default function DeliveryInformationSection({
  deliveryPhone,
  initialAddress,
  disabled = false,
  onDeliveryPhoneChange,
  onAddressChange,
}: DeliveryInformationSectionProps) {
  return (
    <Box sx={{ mt: 2 }}>
      <Typography
        variant="h6"
        sx={{
          fontWeight: 600,
          color: "#111827",
          marginBottom: "20px",
          paddingBottom: "12px",
        }}
      >
        Thông tin giao hàng
      </Typography>

      <Grid container rowSpacing={0} columnSpacing={4}>
        <Grid size={{ xs: 12, md: 6 }}>
          <LabeledField label="SĐT nhận hàng" labelWidth={120}>
            <TextField
              value={deliveryPhone || ""}
              onChange={(e) => onDeliveryPhoneChange(e.target.value)}
              size="small"
              fullWidth
              placeholder="Nhập số điện thoại nhận hàng"
              disabled={disabled}
            />
          </LabeledField>
        </Grid>
      </Grid>

      <Box sx={{ mt: 0 }}>
        <AddressFieldWrapper
          initialAddress={initialAddress}
          onAddressChange={onAddressChange}
          isEditMode={true}
          labelWidth={120}
          styleDisplay="small"
          disabled={disabled}
        />
      </Box>
    </Box>
  );
}